import { mapGetters } from 'vuex'

export const getLimitMixin = {
  computed: {
    ...mapGetters('user', {
      userPlan: 'getUserPlan'
    }),
    getLimit() {
      return v => {
        let limit = this.userPlan ? this.userPlan[v]?.limit : ''
        if (isNaN(+limit)) limit = Infinity
        return limit
      }
    },
    getUsed() {
      return v => this.userPlan ? this.userPlan[v]?.used : ''
    }
  }
}
